import { apiClient, ApiError } from './apiClient';
import { Link } from '../types';

interface GetLinksResponse {
    links: any[];
}

interface CheckPathResponse {
    success: boolean;
    exists: boolean;
}

export const linksApi = {
    async getUserLinks(): Promise<Link[]> {
        try {
            const response = await apiClient.get<GetLinksResponse>('/api/links');

            if (!response.links) {
                throw new ApiError(404, 'Failed to fetch links');
            }

            return response.links.map((link: any) => ({
                id: link.id,
                userId: link.userID,
                path: link.path,
                type: link.type,
                name: link.name,
                description: link.description,
                coverImage: link.coverImage,
                platforms: link.platforms || [],
                itemId: link.itemID,
                theme: link.theme,
                createdAt: link.createdAt,
                updatedAt: link.updatedAt,
            }));
        } catch (error) {
            if (error instanceof ApiError) {
                throw error;
            }
            throw new ApiError(500, 'Failed to fetch links');
        }
    },

    async checkPathExists(path: string): Promise<boolean> {
        try {
            const response = await apiClient.get<CheckPathResponse>(
                `/api/links/check-path/${encodeURIComponent(path)}`
            );
            return response.exists || false;
        } catch (error) {
            console.error('Failed to check path:', error);
            return false;
        }
    }
};
